import * as React from 'react';
import alertic from 'src/assets/images/alert-ic.png';
import closeic from "src/assets/images/close-ic.png"
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import System from "../../../helper/system";
import Helper from 'src/support/Helper';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import CartRepository from 'src/repository/CartRepository';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import QuoteDetail from '@system/config/quote-detail';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import noImage from 'src/assets/images/noimage.png'
import liveAuth from 'src/helper/liveAuth';
import { isArray, isObject } from "underscore";
import QuoteQuantityScheduler from './QuoteQuantityScheduler';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import getSymbolFromCurrency from 'currency-symbol-map';
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductPricingStore } from 'src/hooks/productPricing';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';


// 9063 - DT - 2Feb23 - Update Condition to check valid Quote Product valid for this address or not

const QuoteCartList = () => {
  const [__check] = useAxiosIndicatorCheck();
  const [{ get_current_quote_cart }, { }, { }] = useQuoteDetailStore();
  const [
    { QUOTE_CART_BLACKLISTED_ARR },
    { get_quote_currency, get_cart_quote_number, get_checkout_charge },
    { },
  ] = useCartStore();
  const quoteList = get_current_quote_cart();
  const quoteCurrency = get_quote_currency(quoteList);
  const quoteNumber = get_cart_quote_number();

  const [{ pricingList }, { }, { }] = useProductPricingStore();
  const pricing = pricingList;

  useEffect(() => {
    if (quoteList && Object.entries(quoteList).length < 1) {
      window.location.href = QuoteDetail.getQuoteDetailPageRouteURL({
        quote_number: quoteNumber,
      });
    }
  }, [quoteList]);

  // Ticket : 19126 Change : show banner message on quote cart & cart - PN - 27 May 2024
  useEffect(() => {
    const fetchCheckoutCharges = async () => {
      let res = await get_checkout_charge();
      // if (res?.invoiceAmount) {
      System.alert(
        `Service charge: Avnet charges a ${res?.invoiceAmount || 0}%  of the respective invoice amount due to increased costs and efforts in areas such as compliance, environment, ESG, handling and others.`,
        "warning");
      // }
    };
    fetchCheckoutCharges();
  }, []);

  const onRemoveLineItem = (data) => {
    store.dispatch(
      system_notification({
        name: "ClearQuoteICarttemPopup",
        data,
      })
    );
  };

  const authLoggedIn = (keyIndex) => {
    return liveAuth.check();
  };

  /**
   * Author : Pankaj
   * Date   : 14-08-2023
   * Reason : Hide DX Loader once our component loads.
   */
  React.useEffect(() => {
    if (
      document.getElementsByClassName("snippet") &&
      document.getElementsByClassName("snippet").length > 0
    ) {
      document.getElementsByClassName("snippet")[0].style.display = "none";
    }
  }, [quoteList]);

  // Story # : 16231 Description : Vendor Exclusive code comment for quote cart Date : 30 April 2024
  // const isVendorExcluded = (v) => {
  //     if (QUOTE_CART_BLACKLISTED_ARR && QUOTE_CART_BLACKLISTED_ARR?.length > 0 &&
  //         QUOTE_CART_BLACKLISTED_ARR?.filter(x => x?.partNumber === v?.partNumber && x?.isVendorExcluded === true).length > 0) {
  //         return true;
  //     }
  //     return false;
  // }

  //By Ramya Kannan [Quote cart View cart - Adobe script ]
  const [isQuoteCartViewEvent, setQuoteCartViewEvent] = useState(true);
  useEffect(() => {
    let quoteListMK = [];
    Object.entries(quoteList).map((data) => {
      quoteListMK.push(data[1]);
    });
    if (isArray(quoteListMK) && isQuoteCartViewEvent) {
      quoteViewCartEvent(quoteListMK);
      setQuoteCartViewEvent(false);
    }
  }, [quoteList]);

  function quoteViewCartEvent(quoteListData) {
    let prodDetails = [];
    let quoteDetails = [];
    quoteListData.forEach((data, key) => {
      prodDetails.push(data.product)
      quoteDetails.push(data)
    })
    prodDetails.map((data, ind) => {
      let copyObj = { ...data };
      let inventoryVal = copyObj?.assets?.inventory;
      copyObj.qas = inventoryVal?.qas;
      copyObj.subtotal = (quoteDetails[ind]?.subTotal_quantity_1);
      copyObj.unitPrice = quoteDetails[ind]?.price_quantity_1;
      copyObj.Quantity = quoteDetails[ind]?.quantity_0;
      copyObj.priceSource = getPricing(
        data.ERPMFRPartNumber || data.erpMfrPartNumber,
        data.ERPPartNumber,
        data.ERPPartNumberModified
      )[0]?.priceSource;
      copyObj.quoteID = quoteNumber;
      copyObj.quoteType = "online";
      prodDetails[ind] = copyObj;
    })

    let cartDetails = {
      additionSource: "PLP",
      cartType: "Quote",
      quoteID: quoteDetails[0]?.quoteNumber,
      quoteType: "online"
    };
    localStorage.setItem("adobeEventType", "QuoteCartViewEvent");

    if (Object.keys(prodDetails).length) {
      HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails });
    }
  }

  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };

  return (
    <>
      <div className="bs5 row">
        <div className="col-12">
          <div className="cart-list-table table-responsive">
            <table className="table">
              <tbody>
                {quoteList && Object.entries(quoteList).length > 0 ? (
                  Object.entries(quoteList).map((v, i) => (
                    <React.Fragment key={v[1].uniqueLineItem}>
                      <tr className="">
                        <td className="cart-list-product-img">
                          <div className="product-info nopadding">
                            <span>Item : {i + 1}</span>
                            <div className="product-img sect-1 text-center">
                              <img
                                alt="Product"
                                src={
                                  v[1].product &&
                                    v[1].product.AssetURL !== undefined &&
                                    v[1].product.AssetURL !== null &&
                                    v[1].product.AssetURL.trim() !== ""
                                    ? v[1].product.AssetURL
                                    : noImage
                                }
                              />
                            </div>
                            <div className="prod-option-icon sect-2 d-flex flex-wrap">
                              <ProductLegends
                                single_product={v[1].product}
                                onlyIcon={true}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="cart-list-product-detail">
                          <div className="d-flex ">
                            <div className="product-detail">
                              <div className="product-name">
                                <div className="d-flex align-items-center">
                                  <NavigateToPDP data={{
                                    ManufacturerName: v[1]?.product?.ManufacturerName,
                                    ERPMFRPartNumber: Helper.valueIsNotNull(
                                      v[1]?.ERPMFRPartNumber
                                    )
                                      ? v[1]?.ERPMFRPartNumber
                                      : v[1]?.product
                                        ?.ManufacturerPartNumber,
                                    ItemNumber: v[1]?.product?.ItemNumber,
                                  }}>
                                    <div className="text-blue">
                                      <b>
                                        {Helper.valueIsNotNull(
                                          v[1].ERPMFRPartNumber
                                        )
                                          ? v[1].ERPMFRPartNumber
                                          : v[1].product
                                            ?.ManufacturerPartNumber}{" "}
                                      </b>
                                    </div>
                                  </NavigateToPDP>


                                  {/**
                                   * Ticket #    : 9604
                                   * Change #    : Remove tooltip from the quote cart summary
                                   * Change by # : Pankaj
                                   * Date        : 13 March 2023
                                   */}
                                </div>
                                <div className="text-black-stone cursor-default">
                                  <span className="d-inline text-wrap w-auto">
                                    by{" "}
                                  </span>
                                  <a href={`/${System.siteName()}/manufacturers/m/${v?.[1]?.product?.ManufacturerName?.toLowerCase().replace(/\+/g, "and").replace(/&/g, "and").replace(/\./g, "").replace(/\//g, "-").replace(/,/g, "").replace(/\s/g, '-').replace(/---/g, '-')}`}
                                    target="_blank"
                                    className="text-blue text-break cursor-pointer"
                                  >
                                    {v[1].product?.ManufacturerName}
                                  </a>
                                </div>
                                <div>
                                  {v[1].customerPartNumber.trim() &&
                                    v[1].customerPartNumber !== "*" && (
                                      <div>
                                        <label>
                                          {" "}
                                          <b>Customer Part Number: </b>
                                        </label>
                                        <span>{v[1].customerPartNumber}</span>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="cart-list-product-update">
                          {new CartRepository().checkisValidProduct(
                            v[1].erpManufacturerCode
                          ) === true && (
                              <div className="text-end mb-2">
                                <button
                                  className="bs5 btn btn-secondary btn-sm ms-auto"
                                  onClick={() => onRemoveLineItem(v[1])}
                                >
                                  Remove item from cart
                                </button>
                              </div>
                            )}
                          <div className="qoute-label-value-item">
                            <span className="qoute-label">Quantity:</span>
                            <span className="qoute-value">
                              {v[1][`quantity_${v[1].quantity_field_selected}`]}
                            </span>
                          </div>
                          <div className="qoute-label-value-item">
                            <span className="qoute-label">
                              Quoted Unit Price:
                            </span>
                            <span className="qoute-value">
                              {Helper.getFormatNumber(
                                v[1][
                                `quotedPrice_${v[1].quantity_field_selected}`
                                ],
                                quoteCurrency,
                                getSymbolFromCurrency(quoteCurrency),
                              )}
                            </span>
                          </div>
                          <div className="qoute-label-value-item">
                            <span className="qoute-label">
                              *Additional Charges:
                            </span>
                            <span className="qoute-value">-</span>
                          </div>
                          <div className="qoute-label-value-item">
                            <span className="qoute-label">Subtotal:</span>
                            <span className="qoute-value">
                              {Helper.getFormatNumber(
                                v[1][
                                `subTotal_${v[1].quantity_field_selected}`
                                ],
                                quoteCurrency,
                                getSymbolFromCurrency(quoteCurrency)
                              )}
                            </span>
                          </div>
                          <div>
                            {authLoggedIn() ? (
                              <QuoteQuantityScheduler
                                CART_DATA_SINGLE={v}
                                single_product_inventory={
                                  v[1].product?.assets?.inventory
                                }
                                CART_PRODUCT_DATA={v[1].product}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          {/* {isVendorExcluded(v[1]) &&
                                                        <React.Fragment>
                                                            <div className="text-end mb-2" >
                                                                <button className="bs5 btn btn-secondary btn-sm ms-auto" onClick={() => onRemoveLineItem(v[1])}>Remove item from cart</button>
                                                            </div>
                                                            <AlertContentWithFlag key={Helper.UUID()} message={'Part is not eligible. Remove this item to proceed to Checkout '} type="warning"></AlertContentWithFlag>
                                                        </React.Fragment>
                                                    } */}
                        </td>
                        <td className="cart-list-close">
                          <div
                            className="close-ic"
                            onClick={() => onRemoveLineItem(v[1])}
                          >
                            <img src={closeic} alt="Remove" />
                          </div>
                          {new CartRepository().checkisValidProduct(
                            v[1].erpManufacturerCode
                          ) === true && (
                              <div className="alert alert-danger not-eligible-alert">
                                <img className="me-2" src={alertic} />
                                Part not eligible to ship to country selected.
                                Remove this item to proceed to Checkout.
                              </div>
                            )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))
                ) : (
                  <NoResultContent
                    message={"Sorry! We can't find any results"}
                    isDisplay={false}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};


export default QuoteCartList;